export default "__VITE_ASSET__CElmSRbx__"